import { render, staticRenderFns } from "./TokenField.vue?vue&type=template&id=2981f0bd&scoped=true&"
import script from "./TokenField.vue?vue&type=script&lang=ts&"
export * from "./TokenField.vue?vue&type=script&lang=ts&"
import style0 from "./TokenField.vue?vue&type=style&index=0&id=2981f0bd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2981f0bd",
  null
  
)

export default component.exports